import React from "react";
import Doctor from "../Assets/SNS1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/BookAppointment.css";

function BookAppointment() {
  return (
    <div className="ba-section">
      <div className="ba-image-content">
        <img src={Doctor} alt="Doctor Group" className="ba-image1" />
      </div>

      <div className="ba-text-content">
        <h3 className="ba-title">
          <span>Why Choose SNS Enterprises</span>
        </h3>
        <p className="ba-description">
         Discover why leading architects, contractors, and importers across Europe choose SNS Enterprises for their granite needs. 
         We combine craftsmanship, precision, and reliability to deliver products that 
         stand the test of time — where quality meets global standards.
        </p>
        <p className="ba-checks ba-check-first">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Premium South Indian Granite
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Strict Quality Assurance
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Global Export & Timely Delivery
        </p>
        <p className="ba-checks ba-check-last">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Customer-Focused Service
        </p>
      </div>
    </div>
  );
}
export default BookAppointment;
